export const BASKET_CONTROLLER_ID = 'Basket';
export const CERTIFICATE_CONTROLLER_ID = 'Certificate';
export const CHARACTER_COUNTER_CONTROLLER_ID = 'CharacterCounter';
export const INTRO_CONTROLLER_ID = 'Intro';
export const MENU_CONTROLLER_ID = 'Menu';
export const MESSAGES_CONTROLLER_ID = 'Messages';
export const MONTHLY_DONOR_FORM_CONTROLLER_ID = 'MonthlyDonorForm';
export const PAYMENT_CONTROLLER_ID = 'Payment';
export const PRODUCT_LIST_CONTROLLER_ID = 'ProductList';
export const DONATION_CONTROLLER_ID = 'Donation';
